import React from 'react';
import { Section } from '@antonpodolsky/design-system/regions/section/section';
import { Stack } from '@antonpodolsky/design-system/layout/stack/stack';
import { Text } from '@antonpodolsky/design-system/typography/text/text';
import { Link } from '@antonpodolsky/design-system/typography/link/link';
import { Callout } from '@antonpodolsky/design-system/feedback/callout/callout';

export const HomepageIntro = () => (
  <Section width="sm" compact title="What is Exify?">
    <Stack gap="3xl">
      <Text as="p" variant="body-lg">
        Exify is a browser extension that instantly displays essential EXIF and
        C2PA information on image hover - and lets you explore and search the
        full metadata. Available for Chrome, Firefox, and Microsoft Edge.
      </Text>

      <Callout icon="info">
        Looking to check the EXIF metadata in your local files? Head over to
        Exify&apos;s <Link href="/exif-reader">Online EXIF Reader</Link>.
      </Callout>
    </Stack>
  </Section>
);
